import { createFileRoute } from "@tanstack/react-router";
import AdminDispatchMonitorPage from "@/admin/pages/dispatch-monitor";

export const Route = createFileRoute("/admin/dispatch-monitor/")({
  component: AdminDispatchMonitorPage,
});
